// extracted by mini-css-extract-plugin
module.exports = {"group":"_c808705","fullWidth":"_f24dd96","labels":"_1a1c2e6","label":"_097062c"};